(function () {
    "use strict";

    angular
        .module("app")
        .factory("SearchHelpService", SearchHelpService);

    function SearchHelpService(WebApiService) {

        var service = {
            getFactoryFavorites: getFactoryFavorites,
            getPatternNamesFavorites: getPatternNamesFavorites,
            getPlanningCategoryFavorites: getPlanningCategoryFavorites,
            getCustomerFavorites: getCustomerFavorites,
            searchFactories: searchFactories,
            searchPatternNames: searchPatternNames,
            searchPlanningCategories: searchPlanningCategories,
            searchCustomers: searchCustomers,
            searchCurrencies: searchCurrencies,
            savePersonalFavorite: savePersonalFavorite,
            removePersonalFavorite: removePersonalFavorite,
            getActivityTypeFavorites: getActivityTypeFavorites,
            getStrategicBusinessUnitFavorites: getStrategicBusinessUnitFavorites,
            searchActivityTypes: searchActivityTypes,
            searchStrategicBusinessUnits: searchStrategicBusinessUnits,
            searchRetailChannels: searchRetailChannels,
            getRetailChannelFavorites: getRetailChannelFavorites,
            searchBasicMaterials: searchBasicMaterials,
            getBasicMaterialFavorites: getBasicMaterialFavorites,
            getMidsoleFavorites: getMidsoleFavorites,
            searchMidsoles: searchMidsoles,
            getOutsoleFavorites: getOutsoleFavorites,
            searchOutsoles: searchOutsoles,
            getCollectionFavorites: getCollectionFavorites,
            searchCollections: searchCollections,
            searchBusinessSegments: searchBusinessSegments,
            getBusinessSegmentFavorites: getBusinessSegmentFavorites,
            searchGenders: searchGenders,
            getGenderFavorites: getGenderFavorites,
            searchHTSDutys: searchHTSDutys,
            getHTSDutyFavorites: getHTSDutyFavorites,
            searchProductHierarchys: searchProductHierarchys,
            getProductHierarchyFavorites: getProductHierarchyFavorites,
            searchDivisions: searchDivisions,
            getDivisionFavorites: getDivisionFavorites,
            searchBasicColors: searchBasicColors,
            getBasicColorFavorites: getBasicColorFavorites,
            searchLasts: searchLasts,
            getLastFavorites: getLastFavorites,
            searchConstructions: searchConstructions,
            getConstructionFavorites: getConstructionFavorites,
            searchCuttingPatterns: searchCuttingPatterns,
            getCuttingPatternFavorites: getCuttingPatternFavorites,
            searchUpperDescriptions: searchUpperDescriptions,
            getUpperDescriptionFavorites: getUpperDescriptionFavorites,
            searchMembranes: searchMembranes,
            getMembraneFavorites: getMembraneFavorites,
            searchFreightGroups: searchFreightGroups,
            getFreightGroupFavorites: getFreightGroupFavorites,
            searchMaterialGrids: searchMaterialGrids,
            getMaterialGridFavorites: getMaterialGridFavorites,
            searchQualitys: searchQualitys,
            getQualityFavorites: getQualityFavorites,
            searchCompounds: searchCompounds,
            getCompoundFavorites: getCompoundFavorites,
            searchToeComponents: searchToeComponents,
            getToeComponentFavorites: getToeComponentFavorites,
            searchPatternDescriptions: searchPatternDescriptions,
            getPatternDescriptionFavorites: getPatternDescriptionFavorites,
            searchNrfColors: searchNrfColors,
            getNrfColorFavorites: getNrfColorFavorites,
            searchStoryTypes: searchStoryTypes,
            getStoryTypeFavorites: getStoryTypeFavorites,
            searchConsumerTerritorys: searchConsumerTerritorys,
            getConsumerTerritoryFavorites: getConsumerTerritoryFavorites,
            searchDevelopers: searchDevelopers,
            searchDevelopmentCenters: searchDevelopmentCenters
        };

        return service;

        function searchFactories(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters || { FactoryKey: "*" },
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn || "FactoryKey",
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchFactories", searchObject);
        }

        function searchPatternNames(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchPatternNames", searchObject);
        }

        function getPlanningCategoryFavorites() {
            return WebApiService.get("/api/SearchHelp/GetPlanningCategoryFavorites", '', '', false);
        }

        function searchPlanningCategories(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchPlanningCategories", searchObject);
        }

        function searchCurrencies(currencyKey, currencyName) {
            if (!currencyKey) currencyKey = "";
            if (!currencyName) currencyName = "";
            return WebApiService.get("/api/SearchHelp/SearchCurrencies?currencyKey=" + currencyKey + "&currencyName=" + currencyName, '', '', false);
        }

        function removePersonalFavorite(favoriteEntity, id) {
            if (!favoriteEntity || !id) {
                return WebApiService.noop();
            }

            return WebApiService.postJson("/api/SearchHelp/RemovePersonalFavorite", { favoriteEntity: favoriteEntity, id: id });
        }

        function savePersonalFavorite(favoriteEntity, id) {
            if (!favoriteEntity || !id) {
                return WebApiService.noop();
            }

            return WebApiService.postJson("/api/SearchHelp/SavePersonalFavorite", { favoriteEntity: favoriteEntity, id: id });
        }

        function getFactoryFavorites() {
            return WebApiService.get("/api/SearchHelp/GetFactoryFavorites", '', '', false);
        }

        function getPatternNamesFavorites() {
            return WebApiService.get("/api/SearchHelp/GetPatternNameFavorites", '', '', false);
        }

        function getCustomerFavorites() {
            return WebApiService.get("/api/SearchHelp/GetCustomerFavorites", '', '', false);
        }

        function searchCustomers(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchCustomers", searchObject);
        }

        function getStrategicBusinessUnitFavorites() {
            return WebApiService.get("/api/SearchHelp/GetStrategicBusinessUnitFavorites", '', '', false);
        }

        function searchStrategicBusinessUnits(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchStrategicBusinessUnits", searchObject);
        }

        function getMidsoleFavorites(sapBrandId) {
            return WebApiService.get("/api/SearchHelp/GetMidsoleFavorites?sapBrandId=" + sapBrandId);
        }

        function searchMidsoles(searchParameters, pageNumber, pageSize, sortColumn, sortDirection, brandId) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC",
                brandId: brandId
            };

            return WebApiService.postJson("/api/SearchHelp/SearchMidsoles", searchObject);
        }

        function getOutsoleFavorites(sapBrandId) {
            return WebApiService.get("/api/SearchHelp/GetOutsoleFavorites?sapBrandId=" + sapBrandId);
        }

        function searchOutsoles(searchParameters, pageNumber, pageSize, sortColumn, sortDirection, brandId) {

            var searchObject = {
                searchParameters: searchParameters || { OutsoleName: "*" },
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn || "OutsoleName",
                sortDirection: sortDirection || "ASC",
                brandId: brandId
            };

            return WebApiService.postJson("/api/SearchHelp/SearchOutsoles", searchObject);
        }

        function getRetailChannelFavorites(sapBrandId) {
            return WebApiService.get("/api/SearchHelp/GetRetailChannelFavorites?sapBrandId=" + sapBrandId);
        }

        function searchRetailChannels(searchParameters, pageNumber, pageSize, sortColumn, sortDirection, brandId) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC",
                brandId: brandId
            };

            return WebApiService.postJson("/api/SearchHelp/SearchRetailChannels", searchObject);
        }

        function getBasicMaterialFavorites() {
            return WebApiService.get("/api/SearchHelp/GetBasicMaterialFavorites");
        }

        function searchBasicMaterials(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchBasicMaterials", searchObject);
        }

        function getCollectionFavorites() {
            return WebApiService.get("/api/SearchHelp/GetCollectionFavorites");
        }

        function searchCollections(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchCollections", searchObject);
        }

        function getBusinessSegmentFavorites() {
            return WebApiService.get("/api/SearchHelp/GetBusinessSegmentFavorites");
        }


        function searchBusinessSegments(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchBusinessSegments", searchObject);
        }

        function getGenderFavorites() {
            return WebApiService.get("/api/SearchHelp/GetGenderFavorites");
        }

        function searchGenders(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters || { Genderkey: "*" },
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn || "GenderKey",
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchGenders", searchObject);
        }

        function getHTSDutyFavorites(originCountry, destCountry) {
            return WebApiService.get("/api/SearchHelp/GetHTSDutyFavorites?originCountry=" + originCountry + "&destCountry=" + destCountry);
        }

        function searchHTSDutys(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchHTSDutys", searchObject);
        }

        function getProductHierarchyFavorites(sapBrandId) {
            return WebApiService.get("/api/SearchHelp/GetProductHierarchyFavorites?sapBrandId=" + sapBrandId);
        }

        function searchProductHierarchys(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchProductHierarchys", searchObject);
        }

        function getDivisionFavorites(sapBrandId) {
            return WebApiService.get("/api/SearchHelp/GetDivisionFavorites?sapBrandId=" + sapBrandId);
        }

        function searchDivisions(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters || { DivisionName: "*" },
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn || "DivisionName",
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchDivisions", searchObject);
        }

        function getBasicColorFavorites() {
            return WebApiService.get("/api/SearchHelp/GetBasicColorFavorites");
        }

        function searchBasicColors(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchBasicColors", searchObject);
        }

        function getLastFavorites(brandId) {
            return WebApiService.get("/api/SearchHelp/GetLastFavorites?brandId=" + brandId);
        }

        function searchLasts(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters || { LastName: "*" },
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn || "LastName",
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchLasts", searchObject);
        }

        function getConstructionFavorites() {
            return WebApiService.get("/api/SearchHelp/GetConstructionFavorites");
        }

        function searchConstructions(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchConstructions", searchObject);
        }

        function getCuttingPatternFavorites() {
            return WebApiService.get("/api/SearchHelp/GetCuttingPatternFavorites");
        }

        function searchCuttingPatterns(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchCuttingPatterns", searchObject);
        }

        function getUpperDescriptionFavorites() {
            return WebApiService.get("/api/SearchHelp/GetUpperDescriptionFavorites");
        }

        function searchUpperDescriptions(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchUpperDescriptions", searchObject);
        }

        function getMembraneFavorites() {
            return WebApiService.get("/api/SearchHelp/GetMembraneFavorites");
        }

        function searchMembranes(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchMembranes", searchObject);
        }

        function getMaterialGridFavorites() {
            return WebApiService.get("/api/SearchHelp/GetMaterialGridFavorites");
        }

        function searchMaterialGrids(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchMaterialGrids", searchObject);
        }

        function getFreightGroupFavorites(sapBrandId) {
            return WebApiService.get("/api/SearchHelp/GetFreightGroupFavorites?sapBrandId=" + sapBrandId);
        }

        function searchFreightGroups(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchFreightGroups", searchObject);
        }

        function getQualityFavorites() {
            return WebApiService.get("/api/SearchHelp/GetQualityFavorites");
        }

        function searchQualitys(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchQualitys", searchObject);
        }

        function getCompoundFavorites(sapBrandId) {
            return WebApiService.get("/api/SearchHelp/GetCompoundFavorites?sapBrandId=" + sapBrandId);
        }

        function searchCompounds(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchCompounds", searchObject);
        }

        function getToeComponentFavorites(sapBrandId) {
            return WebApiService.get("/api/SearchHelp/GetToeComponentFavorites?sapBrandId=" + sapBrandId);
        }

        function searchToeComponents(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchToeComponents", searchObject);
        }

        function getPatternDescriptionFavorites() {
            return WebApiService.get("/api/SearchHelp/GetPatternDescriptionFavorites");
        }

        function searchPatternDescriptions(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchPatternDescriptions", searchObject);
        }

        function getNrfColorFavorites(sapBrandId) {
            return WebApiService.get("/api/SearchHelp/GetNrfColorFavorites");
        }

        function searchNrfColors(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchNrfColors", searchObject);
        }

        function getStoryTypeFavorites() {
            return WebApiService.get("/api/SearchHelp/GetStoryTypeFavorites", '', '', false);
        }

        function searchStoryTypes(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchStoryTypes", searchObject);
        }

        function getConsumerTerritoryFavorites() {                                                      
            return WebApiService.get("/api/SearchHelp/GetConsumerTerritoryFavorites", '', '', false);
        }

        function searchConsumerTerritorys(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchConsumerTerritorys", searchObject);
        }

        function getActivityTypeFavorites() {
            return WebApiService.get("/api/SearchHelp/GetActivityTypeFavorites", '', '', false);
        }

        function searchActivityTypes(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchActivityTypes", searchObject);
        }


        function searchDevelopers(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {

            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchDevelopers", searchObject);
        }

        function searchDevelopmentCenters(searchParameters, pageNumber, pageSize, sortColumn, sortDirection) {
            var searchObject = {
                searchParameters: searchParameters,
                pageNumber: pageNumber || 1,
                pageSize: pageSize || 9999,
                sortColumn: sortColumn,
                sortDirection: sortDirection || "ASC"
            };

            return WebApiService.postJson("/api/SearchHelp/SearchDevelopmentCenters", searchObject);
        }
    }
})();
